// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"da4007ea","453":"a820bc2e"}[chunkId] + ".chunk.js";
};